"use client";
import React, { useEffect, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import TopNavThree from "../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../components/Header/Menu/MenuFurniture";
import BreadcrumbProduct from "../../components/Breadcrumb/BreadcrumbProduct";
import Default from "../../components/Product/Detail/Default";
import Footer from "../../components/Footer/Footer";
import NotFound from "../not-found/page";
import { ProductType } from "../../type/ProductType";
import { fetchProductImages, fetchProductText } from "../../data/Productlist";
import { NProgress } from "../../utils/nprogressSetup";

const ProductLoadingOverlay: React.FC = () => (
  <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-white">
    <img
      src="/logo.png"
      alt="Kissaria"
      className="mb-10 h-14 w-auto object-contain opacity-[0.92]"
    />
    <div className="product-page-load-track h-1.5 w-56 rounded-full bg-black/[0.06]">
      <div className="product-page-load-bar" aria-hidden />
    </div>
    <p className="mt-8 text-sm tracking-tight text-secondary">Chargement du produit…</p>
  </div>
);

const ProductDefault: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { id: pathId } = useParams();
  
  // Get product ID from either query parameter or path parameter
  const productId = searchParams.get("id") || pathId || "1";

  const [products, setProducts] = useState<ProductType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [productExists, setProductExists] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    NProgress.start();

    const fetchData = async () => {
      try {
        const textData = await fetchProductText();

        const product = textData.find(
          (product: ProductType) => String(product.id) === String(productId)
        );
        setProductExists(!!product);

        const productsWithImages = await fetchProductImages(textData);
        if (!cancelled) {
          setProducts(productsWithImages);
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
        if (!cancelled) {
          setProductExists(false);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
          NProgress.done();
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
      NProgress.done();
    };
  }, [productId]);

  if (isLoading) {
    return <ProductLoadingOverlay />;
  }

  // Show 404 page only if product doesn't exist in database
  if (productExists === false) {
    return <NotFound />;
  }

  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative w-full">
        <MenuFurniture props="" />
        <BreadcrumbProduct
          data={products}
          productPage="default"
          productId={productId}
        />
      </div>
      <Default data={products} productId={productId} />
      <Footer />
    </>
  );
};

export default ProductDefault;
